export default "__VITE_ASSET__kW2MYWP6__"